import type { Locale } from 'date-fns';
import { da, de, es, hu, lt, pl, pt, ro, sk, sv, uk, enUS } from 'date-fns/locale';

// Maps an app locale code (vue-i18n) to its date-fns Locale so date-fns
// formatters render in the user's language. date-fns locales must be imported
// statically for tree-shaking, so this list is maintained alongside the locale
// JSON files in ./locales. Unknown codes fall back to English.
const localeMap: Record<string, Locale> = { da, de, es, hu, lt, pl, pt, ro, sk, sv, uk, en: enUS };

export const dateFnsLocale = (code: string): Locale => localeMap[code] ?? enUS;
